export default __webpack_public_path__ + "static/media/cw-8.1bb4c924.jpg";